import DashboardApiTableShow, {DashboardColumn, DashboardFilter} from './DashboardApiTableShow'
import {ListingErrorItem} from './dashboardTableTypes'
import {
  // formatDashboardCurrency,
  renderDashboardDateTwoLine,
  renderDashboardErrorWithIcon,
  renderDashboardLinkIcon,
  renderDashboardSku,
  renderDashboardStatusPill,
  renderDashboardTruncatedText,
} from './dashboardFormatters'

const columns: DashboardColumn<ListingErrorItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {
    header: 'Channel',
    sortKey: 'channel',
    minWidth: 130,
    render: (item) => renderDashboardTruncatedText(item.channel),
  },
  {
    header: 'Error Message',
    minWidth: 200,
    render: (item) => renderDashboardErrorWithIcon(item.error_message),
  },
  // {
  //   header: 'Scraped Price',
  //   sortKey: 'scraped_price',
  //   render: (item) =>
  //     item.scraped_price === null || item.scraped_price === undefined || item.scraped_price === ''
  //       ? '-'
  //       : formatDashboardCurrency(item.scraped_price),
  // },
  {header: 'Product Status', sortKey: 'product_status', render: (item) => renderDashboardStatusPill(item.product_status)},
  {
    header: 'Type',
    sortKey: 'type',
    minWidth: 100,
    render: (item) => renderDashboardTruncatedText(item.type),
  },
  {
    header: 'Changed At',
    sortKey: 'scraped_timestamp',
    width: 160,
    render: (item) => renderDashboardDateTwoLine(item.scraped_timestamp),
  },
  {
    header: 'Url',
    width: 120,
    render: (item) => renderDashboardLinkIcon(item.broken_link),
  },
]

const errorTypeFilter: DashboardFilter = {
  param: 'error_type',
  width: 220,
  options: [
    {value: '', label: 'All Listing Errors'},
    {value: 'channel_not_supported', label: 'Unsupported Channel'},
    {value: 'scraped_errors', label: 'Scrape Errors'},
  ],
}

function ListingErrorsShow() {
  return (
    <DashboardApiTableShow<ListingErrorItem>
      endpoint='ListingErrors'
      title='Listing Errors'
      columns={columns}
      filter={errorTypeFilter}
    />
  )
}

export default ListingErrorsShow
